module.exports = __webpack_public_path__ + "static/media/hirebase-logo.6f8dc96a.svg";